// removed by extract-text-webpack-plugin
module.exports = {"wrap-nav-top":"wrap-nav-top","logo":"logo","logo-link":"logo-link","logo-text":"logo-text","content-show-mobile":"content-show-mobile","hide-tablet":"hide-tablet","link-post-demand":"link-post-demand"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_Logo.scss
// module id = ./components/layouts/master/sub-header/_Logo.scss
// module chunks = 0